export default __webpack_public_path__ + "87e0caf06f478030a863789cf37610a0.png";